module.exports = __webpack_public_path__ + "5f67a20461c0aad6f7645a1656684465.fbx";